var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('full-window-wrapper',{staticClass:"full-window-wrapper",attrs:{"height":_vm.resizeState.height,"zindex":_vm.zIndex || 0,"position":'fixed',"bgcolor":_vm.bgcolor || '#FFFFFF'}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }